export const DEFAULT_REVALIDATE_FOR_CONTENT = process.env.DEFAULT_REVALIDATE_FOR_CONTENT
  ? Number.parseInt(process.env.DEFAULT_REVALIDATE_FOR_CONTENT)
  : 60;

export const IMGPROXY_EXPIRES_IN = process.env.IMGPROXY_EXPIRES_IN
  ? Number.parseInt(process.env.IMGPROXY_EXPIRES_IN)
  : 10 * 60; // 10 minutes
export const ONE_YEAR = 60 * 60 * 24 * 365; // seconds — placeholders are immutable (hash-keyed)

export const IMAGE_WIDTH_TIERS = [480, 640, 960, 1280, 1920, 2560,]; // srcset width ladder
export const IMAGE_WIDTH_MIN = Math.min(...IMAGE_WIDTH_TIERS);
export const IMAGE_WIDTH_MAX = Math.max(...IMAGE_WIDTH_TIERS);

export const ALPHABETHICAL = `alphabethical`;
export const NEWEST = `newest`;
export const RATING = `rating`;
export const OLDEST = `oldest`;

export const CUP_ORDER = [`A`, `B`, `C`, `D`, `E`, `F`, `G`, `H`,];

export const EPOCH = 2;

export const ONECLICK_BILLERS = [
  EPOCH,
];

